$.fn.dataTable.Api.register( 'checkedCheckboxes()', function (data) {
    if(typeof data == 'undefined') {
        data = '';
    }

    return this.$('input[type="checkbox"]:checked' + data);
} );
